import { Button, Flex, Typography } from "antd"
import { DeleteOutlined } from "@ant-design/icons"

import csvIcon from "@src/app/assets/icons/upload-.csv-icon.svg"

type Props = {
  name: string
  remove: () => void
}
export const UploadItemRenderCsv = ({ name, remove }: Props) => {
  return (
    <Flex align="center" gap={8} style={{ marginTop: 8 }}>
      <img alt="icon" src={csvIcon} />

      <Typography.Text style={{ color: "#666666" }}>{name}</Typography.Text>

      <Button
        icon={<DeleteOutlined />}
        id="GENERATED_ID_UPLOADITEMRENDERCSV_BUTTON_VOID_1"
        onClick={remove}
        size={"small"}
        style={{ padding: 0 }}
        type={"text"}
      ></Button>
    </Flex>
  )
}
